let url = '/v1/admin/discount';
export const QUOTE_DISCOUNT_ENDPOINT = {
  getQuoteDiscountList: {
    url,
    method: 'GET',
  },
  deleteQuoteDiscount: {
    url,
    method: 'DELETE',
  },
  statusUpdateQuoteDiscount: {
    url: `${url}/change-status`,
    method: 'PUT',
  },
  addQuoteDiscount: {
    url,
    method: 'POST',
  },
  editQuoteDiscount: (id) => ({
    url: `${url}/${id}`,
    method: 'PUT',
  }),
  getQuoteDiscountDetails: (id) => ({
    url: `${url}/${id}`,
    method: 'GET',
  }),
};
